import React from "react";

export const CHAT_NOTIFICATION_IMMEDIATE = "immediate";
export const CHAT_NOTIFICATION_DELAY_UNTIL_MORNING = "delay_until_morning";

export function isLateNightNotificationWindowJst(date = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Tokyo",
      hour: "2-digit",
      hour12: false,
      hourCycle: "h23",
    }).formatToParts(date);
    const hour = Number(parts.find((part) => part.type === "hour")?.value || 0);
    return Number.isFinite(hour) && hour >= 0 && hour < 6;
  } catch {
    const hour = date.getHours();
    return hour >= 0 && hour < 6;
  }
}

export function normalizeClipboardImageFile(file, index = 0) {
  if (!file) return null;
  const mime = String(file.type || "").toLowerCase();
  const extension = mime.includes("jpeg") || mime.includes("jpg") ? "jpg" : "png";
  const timestamp = new Date()
    .toISOString()
    .replace(/[-:]/g, "")
    .replace(/\..+$/, "")
    .replace("T", "-");
  const fallbackName = `clipboard-image-${timestamp}-${index + 1}.${extension}`;
  if (file instanceof File && String(file.name || "").trim()) return file;
  return new File([file], fallbackName, {
    type: file.type || `image/${extension}`,
    lastModified: Date.now(),
  });
}

export function buildComposerHighlightNodes(text, mentionRanges) {
  if (!mentionRanges.length) return text;
  const nodes = [];
  let cursor = 0;
  mentionRanges.forEach((mention, index) => {
    if (mention.start < cursor) return;
    if (cursor < mention.start) {
      nodes.push(
        <span key={`text-${cursor}`}>
          {text.slice(cursor, mention.start)}
        </span>,
      );
    }
    nodes.push(
      <span
        key={`mention-${mention.start}-${index}`}
        className="composer-input-mention-token"
        data-testid="composer-input-mention-token"
      >
        {text.slice(mention.start, mention.end)}
      </span>,
    );
    cursor = mention.end;
  });
  if (cursor < text.length) {
    nodes.push(
      <span key={`text-${cursor}`}>
        {text.slice(cursor)}
      </span>,
    );
  }
  return nodes;
}
